var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-819.000000, -323.000000)",
    strokeWidth: 2.39999986
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "269 106.4117 272.727822 110 280 103"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.07fd0693001167ec73407e568fde4d86.svg";
export { ForwardRef as ReactComponent };